<template>
  <picker-field :label="label" :display="display" title="选择岗位" ref="picker" @open="onSearch">
    <div class="weui-cells weui-cells_checkbox">
      <label
        class="weui-cell weui-cell_active weui-check__label"
        v-for="item in items"
        :key="item.id"
      >
        <div class="weui-cell__hd">
          <input type="checkbox" class="weui-check" v-model="item.checked" @change="onSelect" />
          <i class="weui-icon-checked"></i>
        </div>
        <div class="weui-cell__bd">
          <p>{{item.name}}</p>
        </div>
      </label>
    </div>
  </picker-field>
</template>

<script>
import PickerField from "@/components/field/PickerField.vue";

export default {
  components: {
    PickerField,
  },
  props: {
    label: {
      type: String,
      default: "岗位",
    },
    value: Array,
  },
  data() {
    return {
      items: [],
    };
  },
  computed: {
    display() {
      var selected = this.value;
      if (selected) {
        return selected.map((item) => item.name).join(" ");
      }
      return null;
    },
  },
  methods: {
    onSelect() {
      var me = this,
        items = me.items,
        selected = items.filter((item) => item.checked);
      me.$emit("input", selected);
      me.$emit("select", selected);
    },
    onSearch() {
      var me = this;
      me.$loading({
        url: "/api/account/role/list",
      }).then(function (res) {
        if (res.success) {
          me.items = res.data.map((item) => {
            var checked = false;
            if (me.value) {
              checked = !!me.value.find((i) => i.id == item.id);
            }
            item.checked = checked;
            return item;
          });
        } else {
          me.$weui.topTips(res.message, 2000);
        }
      });
    },
  },
};
</script>